import moment from 'moment';

/** 
 * Es necesario importar todos los posibles idiomas para que
 * la funcion locale() trabaje correctamente con los idiomas disponibles.
 */
import pt from 'moment/locale/pt';
import fr from 'moment/locale/fr';
import es from 'moment/locale/es';
import en from 'moment/locale/en-gb';

export function setRightLanguage() {
   let language = localStorage.getItem('i18nextLng');
   const languagesEnabled = JSON.parse(localStorage.getItem('language_avail'));

   // Con esto, evitamos que se setee un lenguage que no está disponible en la app.
   language = languagesEnabled && languagesEnabled.includes(language) ? language : 'en';

   moment.locale(language);

   /** Modificaciones especiales de cada lenguaje */
   switch (language) {
      case 'pt':
         moment.updateLocale('pt', {
            weekdaysMin: 'do_seg_ter_qua_qui_sex_sá'.split('_')
         });
         break;
   }
}



// WEBPACK FOOTER //
// ./src/services/momentService.js